



// import React, { useEffect, useRef, useState, useContext } from "react";
// import { Link, useHistory } from "react-router-dom";
// import Swal from "sweetalert2";
// import Button from "react-bootstrap/Button";
// import Modal from "react-bootstrap/Modal";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";
// import { BsPerson, BsPencilSquare, BsCheckCircleFill, BsChevronRight } from 'react-icons/bs';
// import { LuIndianRupee } from "react-icons/lu";
// import { apiRequest } from "../../apiService/allApi";
// import Rightcontainer from "../Components/Rightcontainer";

// // Keep your CSS imports
// import "../css/layout.css";
// import css from "../css/Profile.module.css";
// import "../css/kyc.css";
// import "../css/Loader.css";

// const Profile1 = ({ profile }) => {
//   // --- KEEPING ALL YOUR EXISTING LOGIC & STATE UNTOUCHED ---
//   const translations = {
//     hi: { wallet: 'वॉलेट', refer: 'किसी मित्र का रेफर कोड इस्तेमाल करे', win: 'पैसा जिता', game: 'गेम खेला', referEarn: 'रेफरल कमाई', referPerson: 'आमंत्रित किये दोस्त' },
//     en: { wallet: 'My Wallet', refer: 'Use Refer Code', Win: 'Coin Won', game: 'Battle Played', referEarn: 'Referral Earning', referPerson: 'Referred Players' },
//   };

//   const { language } = useContext(LanguageContext);
//   const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const [show, setShow] = useState(false);
//   const [show1, setShow1] = useState(false);
//   const handleClose = () => setShow1(false);
//   const handleShow = () => setShow1(true);
//   const [referral, setCode] = useState("");
//   const [Id, setId] = useState(null);
//   const [msg, setMsg] = useState("");
//   const [portcss, setPortcss] = useState(css.active_tab);
//   const [portcss1, setPortcss1] = useState(css.inactive_tab);
//   const [holder_name, setHolder_name] = useState();
//   const [account_number, setAccount_number] = useState();
//   const [ifsc_code, setIfsc_code] = useState();
//   const [upi_id, setUpi_id] = useState();
//   const [isLoading, setIsloading] = useState(false);
//   const [showKyc, setShowKyc] = useState(false);
//   const [process1, setProcesss] = useState(false);

//   const udata = localStorage.getItem("udata");
//   const profileData = JSON.parse(udata);
//   const siteData = localStorage.getItem("sitSetting");
//   const SData = JSON.parse(siteData) || {};

//   const handleCloseKyc = () => setShowKyc(false);
//   const handleShowKyc = () => setShowKyc(true);
//   const [inputOpen, setInputOpen] = useState(false);
//   const [Email, setEmail] = useState(null);
//   const toggleInput = () => setInputOpen(!inputOpen);
//   const history = useHistory();

//   // --- ALL YOUR FUNCTIONS (NOT MODIFIED) ---
//   const logout = async () => {
//     localStorage.clear();
//     let access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     await apiRequest(`me`, "GET", null, headers)
//       .then(() => { /* logic */ })
//       .catch((e) => {
//         if (e.response?.status === 401) {
//           localStorage.removeItem("token");
//           window.location.reload();
//           history.push("/login");
//         }
//       });
//   };

//   const UpdateEmail = async () => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     if (Email != null) {
//       try {
//         const respone = await apiRequest(`user/profile/edit`, "PATCH", { Email }, headers);
//         if (respone.data.status === false) {
//           Swal.fire({ title: respone.data.msg, icon: "error" });
//         } else {
//           setEmail(respone.data); setInputOpen(false);
//           Swal.fire({ title: respone.data.msg, icon: "success" });
//         }
//       } catch (error) {}
//     } else {
//       Swal.fire({ title: "Please enter your Email", icon: "error" });
//     }
//   };

//   const [Name, setName] = useState(null);
//   const UpdateProfile = async () => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     if (Name != null) {
//       const respone = await apiRequest(`user/profile/edit`, "PATCH", { Name }, headers);
//       if (respone.data.status === false) {
//         Swal.fire({ title: respone.data.msg, icon: "error" });
//       } else {
//         setName(respone.data);
//         Swal.fire({ title: respone.data.msg, icon: "success" });
//       }
//     }
//   };

//   const [total, setTotal] = useState();
//   const TotalGame = async () => {
//     let access_token = localStorage.getItem("token");
//     let userId = localStorage.getItem("userId");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     try {
//       const res = await apiRequest(`total/user/all/${userId}`, "GET", null, headers);
//       if (res.data) setTotal(res.data);
//     } catch (e) {}
//   };

//   const Result = async (file) => {
//     if (file) {
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const formData = new FormData();
//       formData.append("avatar", file);
//       await apiRequest(`users/me/avatar`, "POST", formData, headers);
//     }
//   };

//   const Kyc = () => setShowKyc(true);

//   const [AadharNum, setAadharNum] = useState("");
//   const [userAdharData, setUserAdharData] = useState("");
//   const handleAdharChnage = (e) => setAadharNum(e.target.value);

//   const AdharNumber = async (e) => {
//     setIsloading(true); e.preventDefault();
//     if (/^[0-9]{12}$/.test(AadharNum)) {
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const data = { aadharNumber: AadharNum };
//       try {
//         const res = await apiRequest("aadharcard-auto", "POST", data, headers);
//         setUserAdharData(res?.data);
//         setIsloading(false);
//         if (res.data.status === false) setMsg(res?.data?.msg);
//         else setMsg(res?.data?.data?.message);
//       } catch (error) { console.log(error); }
//     } else {
//       Swal.fire({ icon: "error", title: "Invalid Verification Number", text: "12-digit number required" });
//       setIsloading(false);
//     }
//   };

//   const [AadharOtp, setAadharOtp] = useState("");
//   const [isLoading1, setIsloading1] = useState(false);
//   const handleAdharOtpChnage = (e) => setAadharOtp(e.target.value);

//   const AdharOtpFunc = async (e) => {
//     setIsloading1(true);
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     const data = { aadharNumber: AadharNum, otp: AadharOtp, Email: Email, transaction_id: userAdharData.data?.ref_id };
//     try {
//       const res = await apiRequest(`aadharcard-auto-verify`, "POST", data, headers);
//       setIsloading1(false);
//       if (res.data.status === false) setMsg(res.data?.msg);
//       else window.location.reload();
//     } catch (e) { console.log(e); }
//   };

//   let aadharProcess = useRef(false);
//   const [Names, setNames] = useState("");
//   const [DOB, setDob] = useState("");
//   const [frontLoaded, setFrontLoaded] = useState(null);
//   const [backLoaded, setBackLoaded] = useState(null);

//   const handleSubmitdata = async (e) => {
//     e.preventDefault();
//     if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
//       alert("All fields required"); return;
//     }
//     if (aadharProcess.current === false) {
//       setProcesss(true); aadharProcess.current = true;
//       const formData = new FormData();
//       formData.append("Name", Names); formData.append("DOB", DOB);
//       formData.append("front", frontLoaded[0]); formData.append("back", backLoaded[0]);
//       formData.append("Number", AadharNum); formData.append("Email", Email);
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const res = await apiRequest(`aadharcard`, "POST", formData, headers);
//       if (res.data.status === false) {
//         Swal.fire({ title: res.data.msg, icon: "error" }).then(() => handleCloseKyc());
//       } else {
//         Swal.fire({ title: "KYC submitted", icon: "success" }).then(() => handleCloseKyc());
//         history.push("/Profile");
//       }
//       aadharProcess.current = false; setProcesss(false);
//     }
//   };

//   useEffect(() => { TotalGame(); }, []);

//   const [isValidEmail, setIsValidEmail] = useState(true);
//   const handleEmailChange = (e) => {
//     const newEmail = e.target.value;
//     setEmail(newEmail);
//     const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
//     setIsValidEmail(emailRegex.test(newEmail) && newEmail.toLowerCase().endsWith(".com"));
//   };

//   return (
//     <>
//       <div className={`leftContainer ${css.profileWrapper}`}>
//         {/* Background ambient light glow */}
//         <div className={css.ambientGlow1}></div>
//         <div className={css.ambientGlow2}></div>

//         <div className={css.profilePageNew}>
          
//           {/* 1. Profile Header Card */}
//           <div className={`${css.premiumCard} mb-3`}>
//             <div className={css.cardAccent}></div>
//             <div className="d-flex align-items-center p-3">
//               <div className={`${css.avatarContainer} position-relative`}>
//                 <label style={{ cursor: 'pointer' }}>
//                   <input type="file" className="d-none" accept="image/*" onChange={(e) => Result(e.target.files[0])} />
//                   <img 
//                     src={profileData?.avatar ? `${baseUrl}/${profileData.avatar}` : "./images/avatars/Avatar1.png"} 
//                     alt="User" 
//                     className={css.mainProfileImg}
//                   />
//                   <div className={css.cameraBadge}><BsPencilSquare size={12}/></div>
//                 </label>
//               </div>
//               <div className="ms-3 flex-grow-1 overflow-hidden">
//                 {portcss === css.active_tab ? (
//                   <div className="d-flex align-items-center">
//                     <h2 className={`${css.profileNameText} mb-0 text-truncate`}>{profile?.Name || "Player"}</h2>
//                     <BsPencilSquare 
//                       className={`${css.editIconBtn} ms-2 flex-shrink-0`} 
//                       onClick={() => { setPortcss(css.inactive_tab); setPortcss1(css.active_tab); }}
//                     />
//                   </div>
//                 ) : (
//                   <div className="d-flex align-items-center gap-2">
//                     <input 
//                       type="text" 
//                       className={css.editNameInput} 
//                       value={Name || profile?.Name || ""} 
//                       onChange={(e) => setName(e.target.value)} 
//                     />
//                     <button className={css.btnSaveName} onClick={() => { setPortcss(css.active_tab); setPortcss1(css.inactive_tab); UpdateProfile(); }}>
//                       <BsCheckCircleFill />
//                     </button>
//                   </div>
//                 )}
//               </div>
//               <div className={`${css.kycBadgeArea} ms-2 flex-shrink-0`}>
//                  {profile?.verified === "verified" ? (
//                    <span className={css.badgeVerified}>VERIFIED</span>
//                  ) : (
//                    <span className={css.badgePending} onClick={Kyc}>UNVERIFIED</span>
//                  )}
//               </div>
//             </div>
//           </div>

//           {/* 2. Stats Grid */}
//           <div className={`${css.statsGridPremium} mb-3`}>
//              <div className={`${css.statItem} ${css.blueGlow}`}>
//                 <img src="/images/crossswords.png" alt="" />
//                 <div className={css.statText}>
//                   <span className={css.statLabel}>{translations[language]?.game || "Battle Played"}</span>
//                   <h3 className={css.statVal}>{String(total?.stringValue ?? total ?? "0")}</h3>
//                 </div>
//              </div>
//              <div className={`${css.statItem} ${css.goldGlow}`}>
//                 <img src="/Coin without Glow.gif" alt="" />
//                 <div className={css.statText}>

//                   <span className={css.statLabel}>{translations[language]?.Win || "Coin Won"}</span>
//                   <h3 className={css.statVal}>₹{profile?.wonAmount}</h3>
//                 </div>
//              </div>
//              <div className={`${css.statItem} ${css.greenGlow}`}>
//                 <img src="/images/refer1.png" alt="" />
//                 <div className={css.statText}>
//                   <span className={css.statLabel}>Referral</span>
//                   <h3 className={css.statVal}>₹{profile?.referral_earning}</h3>
//                 </div>
//              </div>
//              <div className={`${css.statItem} ${css.purpleGlow}`}>
//                 <img src="/images/cash-withdrawal.png" alt="" />
//                 <div className={css.statText}>
//                   <span className={css.statLabel}>Withdrawal</span>
//                   <h3 className={css.statVal}>₹{profile?.withdrawAmount}</h3>
//                 </div>
//              </div>
//           </div>

//           {/* 3. Account Details List */}
//           <div className={`${css.accountDetailsCard} p-3 mb-4`}>
//              <h4 className={css.sectionTitle}>Account Settings</h4>
             
//              <div className={`${css.detailRow} d-flex justify-content-between align-items-center`}>
//                 <div className="d-flex align-items-center overflow-hidden me-2">
//                    <div className={`${css.rowIcon} flex-shrink-0`}><img src="/images/phone.png" width="20" alt="Phone"/></div>
//                    <div className="row_content ms-3 text-truncate">
//                       <label className={css.detailLabel}>Phone Number</label>
//                       <p className={`${css.detailValue} text-truncate`}>{profile?.Phone}</p>
//                    </div>
//                 </div>
//              </div>

//              <div className={`${css.detailRow} d-flex justify-content-between align-items-center`}>
//                 <div className="d-flex align-items-center overflow-hidden me-2">
//                    <div className={`${css.rowIcon} flex-shrink-0`}><img src="/images/mail.png" width="20" alt="Mail"/></div>
//                    <div className="row_content ms-3 text-truncate">
//                       <label className={css.detailLabel}>Email ID</label>
//                       <p className={`${css.detailValue} text-truncate`}>{profile?.Email || "Not Updated"}</p>
//                    </div>
//                 </div>
//                 <BsPencilSquare className={`${css.editIconBtn} flex-shrink-0`} onClick={toggleInput}/>
//              </div>

//              {inputOpen && (
//                 <div className={`${css.emailUpdateBox} mt-2 mb-2`}>
//                    <input 
//                     type="email" 
//                     className={css.modernInput} 
//                     placeholder="New Email Address" 
//                     value={Email || ""} 
//                     onChange={handleEmailChange}
//                    />
//                    <button className={`${css.btnUpdateEmail} mt-2 w-100`} onClick={UpdateEmail}>Update Email</button>
//                 </div>
//              )}

//              <div className={`${css.detailRow} border-0 d-flex justify-content-between align-items-center`} onClick={Kyc} style={{cursor:'pointer'}}>
//                 <div className="d-flex align-items-center me-2">
//                    <div className={`${css.rowIcon} flex-shrink-0`}><img src="/images/kyc.png" width="20" alt="KYC"/></div>
//                    <div className="row_content ms-3">
//                       <label className={css.detailLabel}>KYC Status</label>
//                       <p className={profile?.verified === "verified" ? css.textSuccess : css.textWarning}>
//                         {profile?.verified === "verified" ? "Verified User" : "Complete KYC Verification"}
//                       </p>
//                    </div>
//                 </div>
//                 <BsChevronRight className={`${css.arrowRight} flex-shrink-0`}/>
//              </div>
//           </div>

//           {/* Logout Action Button */}
//           <div className="text-center my-4">
//              <button className={css.premiumLogoutBtn} onClick={logout}>
//                 <span>LOGOUT ACCOUNT</span>
//              </button>
//           </div>
//         </div>

//         {/* --- MODAL (Functionality Untouched, Light Theme UI Cleaned) --- */}
//         <Modal show={showKyc} onHide={handleCloseKyc} centered className={css.lightModal}>
//           <Modal.Header closeButton className="border-0 pb-0">
//             <Modal.Title className={css.modalTitle}>Verification Center</Modal.Title>
//           </Modal.Header>
//           <Modal.Body className="pt-2">
//             <ul className={`nav nav-pills ${css.modernTabs} mb-3`} id="kycTab" role="tablist">
//               {SData.onlineKYC && (
//                 <li className="nav-item flex-fill">
//                   <button className="nav-link active w-100" id="online-tab" data-bs-toggle="tab" data-bs-target="#online">Online</button>
//                 </li>
//               )}
//               {SData.offlineKYC && (
//                 <li className="nav-item flex-fill">
//                   <button className="nav-link w-100" id="offline-tab" data-bs-toggle="tab" data-bs-target="#offline">Offline Kyc</button>
//                 </li>
//               )}
//             </ul>
            
//             <div className="tab-content mt-3">
//               {SData.onlineKYC && (
//                 <div className="tab-pane fade show active" id="online">
//                    <div className="form-group mb-3">
//                       <label className="small text-secondary mb-1">Verification Identification Number</label>
//                       <input type="number" className={css.modernInput} value={AadharNum} onChange={handleAdharChnage} placeholder="12 Digit Identification Number" />
//                       <p className="text-danger small mt-1">{msg}</p>
//                    </div>
//                    {isLoading ? <div className="text-center"><img src='/images/LandingPage_img/loader1.gif' width="40" alt="loader"/></div> : 
//                     userAdharData?.data?.status !== "SUCCESS" && <button className={css.btnPremiumModal} onClick={AdharNumber}>Send OTP</button>
//                    }
//                    {userAdharData?.data?.status === "SUCCESS" && (
//                      <div className="mt-3">
//                         <input type="number" className={css.modernInput} value={AadharOtp} onChange={handleAdharOtpChnage} placeholder="Enter OTP" />
//                         <button className={`${css.btnPremiumModal} mt-2`} onClick={AdharOtpFunc}>Submit OTP</button>
//                      </div>
//                    )}
//                 </div>
//               )}
//               {SData.offlineKYC && (
//                 <div className="tab-pane fade" id="offline">
//                    <input type="text" className={`${css.modernInput} mb-3`} placeholder="Full Name" value={Names} onChange={(e)=>setNames(e.target.value)} />
//                    <input type="text" className={`${css.modernInput} mb-3`} placeholder="Identification Number" value={AadharNum} onChange={handleAdharChnage} />
//                    <input type="date" className={`${css.modernInput} mb-3`} value={DOB} onChange={(e)=>setDob(e.target.value)} />
//                    <div className={`${css.fileUploadArea} mb-3`}>
//                       <label>Front Photo</label>
//                       <input type="file" onChange={(e)=>setFrontLoaded(e.target.files)} accept="image/*" className="mt-1" />
//                    </div>
//                    <div className={`${css.fileUploadArea} mb-3`}>
//                       <label>Back Photo</label>
//                       <input type="file" onChange={(e)=>setBackLoaded(e.target.files)} accept="image/*" className="mt-1" />
//                    </div>
//                    <button className={css.btnPremiumModal} onClick={handleSubmitdata}>Submit Verification</button>
//                 </div>
//               )}
//             </div>
//           </Modal.Body>
//         </Modal>
//       </div>

//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>
//     </>
//   );
// };

// export default Profile1;


import React, { useEffect, useRef, useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { BsPerson, BsPencilSquare, BsCheckCircleFill, BsChevronRight, BsShieldCheck, BsEnvelope, BsTelephone, BsWallet2, BsBoxArrowRight } from 'react-icons/bs';
import { LuIndianRupee } from "react-icons/lu";
import { apiRequest } from "../../apiService/allApi";
import Rightcontainer from "../Components/Rightcontainer";

// Keep your CSS imports
import "../css/layout.css";
import css from "../css/Profile.module.css";
import "../css/kyc.css";
import "../css/Loader.css";

const Profile1 = ({ profile }) => {
  // --- KEEPING ALL YOUR EXISTING LOGIC & STATE UNTOUCHED ---
  const translations = {
    hi: { wallet: 'वॉलेट', refer: 'किसी मित्र का रेफर कोड इस्तेमाल करे', win: 'पैसा जिता', game: 'गेम खेला', referEarn: 'रेफरल कमाई', referPerson: 'आमंत्रित किये दोस्त' },
    en: { wallet: 'My Wallet', refer: 'Use Refer Code', Win: 'Coin Won', game: 'Battle Played', referEarn: 'Referral Earning', referPerson: 'Referred Players' },
  };

  const { language } = useContext(LanguageContext);
  const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const handleClose = () => setShow1(false);
  const handleShow = () => setShow1(true);
  const [referral, setCode] = useState("");
  const [Id, setId] = useState(null);
  const [msg, setMsg] = useState("");
  const [portcss, setPortcss] = useState(css.active_tab);
  const [portcss1, setPortcss1] = useState(css.inactive_tab);
  const [holder_name, setHolder_name] = useState();
  const [account_number, setAccount_number] = useState();
  const [ifsc_code, setIfsc_code] = useState();
  const [upi_id, setUpi_id] = useState();
  const [isLoading, setIsloading] = useState(false);
  const [showKyc, setShowKyc] = useState(false);
  const [process1, setProcesss] = useState(false);

  const udata = localStorage.getItem("udata");
  const profileData = JSON.parse(udata);
  const siteData = localStorage.getItem("sitSetting");
  const SData = JSON.parse(siteData) || {};

  const handleCloseKyc = () => setShowKyc(false);
  const handleShowKyc = () => setShowKyc(true);
  const [inputOpen, setInputOpen] = useState(false);
  const [Email, setEmail] = useState(null);
  const toggleInput = () => setInputOpen(!inputOpen);
  const history = useHistory();

  // --- ALL YOUR FUNCTIONS (NOT MODIFIED) ---
  const logout = async () => {
    localStorage.clear();
    let access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    await apiRequest(`me`, "GET", null, headers)
      .then(() => { /* logic */ })
      .catch((e) => {
        if (e.response?.status === 401) {
          localStorage.removeItem("token");
          window.location.reload();
          history.push("/login");
        }
      });
  };

  const UpdateEmail = async () => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    if (Email != null) {
      try {
        const respone = await apiRequest(`user/profile/edit`, "PATCH", { Email }, headers);
        if (respone.data.status === false) {
          Swal.fire({ title: respone.data.msg, icon: "error" });
        } else {
          setEmail(respone.data); setInputOpen(false);
          Swal.fire({ title: respone.data.msg, icon: "success" });
        }
      } catch (error) {}
    } else {
      Swal.fire({ title: "Please enter your Email", icon: "error" });
    }
  };

  const [Name, setName] = useState(null);
  const UpdateProfile = async () => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    if (Name != null) {
      const respone = await apiRequest(`user/profile/edit`, "PATCH", { Name }, headers);
      if (respone.data.status === false) {
        Swal.fire({ title: respone.data.msg, icon: "error" });
      } else {
        setName(respone.data);
        Swal.fire({ title: respone.data.msg, icon: "success" });
      }
    }
  };

  const [total, setTotal] = useState();
  const TotalGame = async () => {
    let access_token = localStorage.getItem("token");
    let userId = localStorage.getItem("userId");
    const headers = { Authorization: `Bearer ${access_token}` };
    try {
      const res = await apiRequest(`total/user/all/${userId}`, "GET", null, headers);
      if (res.data) setTotal(res.data);
    } catch (e) {}
  };

  const Result = async (file) => {
    if (file) {
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const formData = new FormData();
      formData.append("avatar", file);
      await apiRequest(`users/me/avatar`, "POST", formData, headers);
    }
  };

  const Kyc = () => setShowKyc(true);

  const [AadharNum, setAadharNum] = useState("");
  const [userAdharData, setUserAdharData] = useState("");
  const handleAdharChnage = (e) => setAadharNum(e.target.value);

  const AdharNumber = async (e) => {
    setIsloading(true); e.preventDefault();
    if (/^[0-9]{12}$/.test(AadharNum)) {
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const data = { aadharNumber: AadharNum };
      try {
        const res = await apiRequest("aadharcard-auto", "POST", data, headers);
        setUserAdharData(res?.data);
        setIsloading(false);
        if (res.data.status === false) setMsg(res?.data?.msg);
        else setMsg(res?.data?.data?.message);
      } catch (error) { console.log(error); }
    } else {
      Swal.fire({ icon: "error", title: "Invalid Verification Number", text: "12-digit number required" });
      setIsloading(false);
    }
  };

  const [AadharOtp, setAadharOtp] = useState("");
  const [isLoading1, setIsloading1] = useState(false);
  const handleAdharOtpChnage = (e) => setAadharOtp(e.target.value);

  const AdharOtpFunc = async (e) => {
    setIsloading1(true);
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    const data = { aadharNumber: AadharNum, otp: AadharOtp, Email: Email, transaction_id: userAdharData.data?.ref_id };
    try {
      const res = await apiRequest(`aadharcard-auto-verify`, "POST", data, headers);
      setIsloading1(false);
      if (res.data.status === false) setMsg(res.data?.msg);
      else window.location.reload();
    } catch (e) { console.log(e); }
  };

  let aadharProcess = useRef(false);
  const [Names, setNames] = useState("");
  const [DOB, setDob] = useState("");
  const [frontLoaded, setFrontLoaded] = useState(null);
  const [backLoaded, setBackLoaded] = useState(null);

  const handleSubmitdata = async (e) => {
    e.preventDefault();
    if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
      alert("All fields required"); return;
    }
    if (aadharProcess.current === false) {
      setProcesss(true); aadharProcess.current = true;
      const formData = new FormData();
      formData.append("Name", Names); formData.append("DOB", DOB);
      formData.append("front", frontLoaded[0]); formData.append("back", backLoaded[0]);
      formData.append("Number", AadharNum); formData.append("Email", Email);
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const res = await apiRequest(`aadharcard`, "POST", formData, headers);
      if (res.data.status === false) {
        Swal.fire({ title: res.data.msg, icon: "error" }).then(() => handleCloseKyc());
      } else {
        Swal.fire({ title: "KYC submitted", icon: "success" }).then(() => handleCloseKyc());
        history.push("/Profile");
      }
      aadharProcess.current = false; setProcesss(false);
    }
  };

  useEffect(() => { TotalGame(); }, []);

  const [isValidEmail, setIsvalidEmail] = useState(true);
  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    setIsvalidEmail(emailRegex.test(newEmail) && newEmail.toLowerCase().endsWith(".com"));
  };

  return (
    <div className="sa-luxury-wallet-wrapper leftContainer mt-5 pt-5">
      {/* Background ambient lighting blur effects matching luxury theme */}
      <div className="ambient-glow glow-one"></div>
      <div className="ambient-glow glow-two"></div>
      <div className="ambient-glow glow-three"></div>

      <div className="sa-luxury-layout-grid refer-layout-extended ">
        <div className="sa-wallet-container refer-master-box profile-master-panel">
          
          {/* 1. Profile Header Hero Card */}
          <div className="profile-hero-card">
            <div className="hero-glow-effect"></div>
            <div className="profile-avatar-row">
              <div className="profile-avatar-box position-relative">
                <label style={{ cursor: 'pointer' }}>
                  <input type="file" className="d-none" accept="image/*" onChange={(e) => Result(e.target.files[0])} />
                  <img 
                    src={profileData?.avatar ? `${baseUrl}/${profileData.avatar}` : "./images/avatars/Avatar1.png"} 
                    alt="User" 
                    className="profile-avatar-img"
                  />
                  <div className="profile-camera-badge"><BsPencilSquare size={13}/></div>
                </label>
              </div>

              <div className="profile-identity-info">
                {portcss === css.active_tab ? (
                  <div className="d-flex align-items-center gap-2">
                    <h2 className="profile-display-name text-truncate">{profile?.Name || "Player"}</h2>
                    <button 
                      className="profile-inline-edit-btn" 
                      onClick={() => { setPortcss(css.inactive_tab); setPortcss1(css.active_tab); }}
                      title="Edit Name"
                    >
                      <BsPencilSquare size={14}/>
                    </button>
                  </div>
                ) : (
                  <div className="profile-edit-input-group">
                    <input 
                      type="text" 
                      className="profile-name-text-input" 
                      value={Name || profile?.Name || ""} 
                      onChange={(e) => setName(e.target.value)} 
                      autoFocus
                    />
                    <button className="profile-save-name-btn" onClick={() => { setPortcss(css.active_tab); setPortcss1(css.inactive_tab); UpdateProfile(); }}>
                      <BsCheckCircleFill size={16}/>
                    </button>
                  </div>
                )}
                {/* <span className="profile-unique-id">ID: {profile?.id || profile?.Phone || "BAJIGER VIP"}</span> */}
              </div>

              <div className="profile-kyc-status-pill">
                 {profile?.verified === "verified" ? (
                   <span className="badge-verified-glow"><BsShieldCheck size={12}/> VERIFIED</span>
                 ) : (
                   <span className="badge-unverified-glow" onClick={Kyc}><BsShieldCheck size={12}/> UNVERIFIED</span>
                 )}
              </div>
            </div>
          </div>

          {/* 2. Stats Grid */}
          <div className="stats-grid profile-stats-grid">
             <div className="sa-stat-box network-card">
                <div className="sa-stat-header">
                  <span className="sa-stat-dot blue"></span>
                  <span className="sa-stat-label">{translations[language]?.game || "Battle Played"}</span>
                </div>
                <span className="sa-stat-value">{String(total?.stringValue ?? total ?? "0")}</span>
             </div>

             <div className="sa-stat-box earnings-card">
                <div className="sa-stat-header">
                  <span className="sa-stat-dot gold"></span>
                  <span className="sa-stat-label">{translations[language]?.Win || "Coin Won"}</span>
                </div>
                <span className="sa-stat-value gold-text">₹{profile?.wonAmount || 0}</span>
             </div>

             <div className="sa-stat-box">
                <div className="sa-stat-header">
                  <span className="sa-stat-dot green"></span>
                  <span className="sa-stat-label">Referral Earning</span>
                </div>
                <span className="sa-stat-value">₹{profile?.referral_earning || 0}</span>
             </div>

             <div className="sa-stat-box">
                <div className="sa-stat-header">
                  <span className="sa-stat-dot purple"></span>
                  <span className="sa-stat-label">Withdrawal</span>
                </div>
                <span className="sa-stat-value">₹{profile?.withdrawAmount || 0}</span>
             </div>
          </div>

          {/* 3. Account Settings Section */}
          <div className="profile-settings-card">
             <h4 className="profile-card-title">Account Settings</h4>
             
             <div className="profile-setting-row">
                <div className="setting-row-left">
                   <div className="setting-icon-box phone-bg">
                      <BsTelephone size={18}/>
                   </div>
                   <div className="setting-info-text">
                      <label>Phone Number</label>
                      <p>{profile?.Phone || "Not Provided"}</p>
                   </div>
                </div>
                <span className="setting-verified-tag">Secured</span>
             </div>

             <div className="profile-setting-row">
                <div className="setting-row-left">
                   <div className="setting-icon-box mail-bg">
                      <BsEnvelope size={18}/>
                   </div>
                   <div className="setting-info-text">
                      <label>Email Address</label>
                      <p>{profile?.Email || "Not Updated"}</p>
                   </div>
                </div>
                <button className="setting-action-edit-btn" onClick={toggleInput}>
                   <BsPencilSquare size={16}/> Edit
                </button>
             </div>

             {inputOpen && (
                <div className="profile-email-update-form">
                   <input 
                    type="email" 
                    className="profile-input-field" 
                    placeholder="Enter new email address..." 
                    value={Email || ""} 
                    onChange={handleEmailChange}
                   />
                   <button className="sa-btn sa-btn-add w-100" onClick={UpdateEmail}>Save New Email</button>
                </div>
             )}

             <div className="profile-setting-row clickable-row" onClick={Kyc}>
                <div className="setting-row-left">
                   <div className="setting-icon-box kyc-bg">
                      <BsShieldCheck size={18}/>
                   </div>
                   <div className="setting-info-text">
                      <label>KYC Verification</label>
                      <p className={profile?.verified === "verified" ? "text-success-custom" : "text-warning-custom"}>
                        {profile?.verified === "verified" ? "Account Fully Verified" : "Complete Verification Now"}
                      </p>
                   </div>
                </div>
                <BsChevronRight size={18} className="setting-arrow-icon"/>
             </div>
          </div>

          {/* Logout Action Button */}
          <div className="profile-logout-container mb-4">
             <button className="profile-luxury-logout-btn" onClick={logout}>
                <BsBoxArrowRight size={18}/>
                <span>LOGOUT </span>
             </button>
          </div>

        </div>

        {/* Right Container Sidebar */}
        <div className="rightContainer mobile-hide">
          <Rightcontainer />
        </div>
      </div>

      {/* --- MODAL (Functionality Untouched, Styled to Match Luxury Theme) --- */}
      <Modal show={showKyc} onHide={handleCloseKyc} centered className="luxury-custom-modal">
        <Modal.Header closeButton className="border-0 pb-0 modal-header-dark">
          <Modal.Title className="modal-title-luxury">Verification Center</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-3 modal-body-dark">
          <ul className={`nav nav-pills modern-modal-tabs mb-4`} id="kycTab" role="tablist">
            {SData.onlineKYC && (
              <li className="nav-item flex-fill">
                <button className="nav-link active w-100" id="online-tab" data-bs-toggle="tab" data-bs-target="#online">Online Verification</button>
              </li>
            )}
            {SData.offlineKYC && (
              <li className="nav-item flex-fill">
                <button className="nav-link w-100" id="offline-tab" data-bs-toggle="tab" data-bs-target="#offline">Manual Upload</button>
              </li>
            )}
          </ul>
          
          <div className="tab-content mt-2">
            {SData.onlineKYC && (
              <div className="tab-pane fade show active" id="online">
                 <div className="form-group mb-3">
                    <label className="modal-input-label">Identification Number</label>
                    <input type="number" className="profile-input-field mt-1" value={AadharNum} onChange={handleAdharChnage} placeholder="Enter 12-digit number" />
                    {msg && <p className="text-danger small mt-2">{msg}</p>}
                 </div>
                 {isLoading ? (
                   <div className="text-center py-3"><img src='/images/LandingPage_img/loader1.gif' width="40" alt="loader"/></div>
                 ) : (
                   userAdharData?.data?.status !== "SUCCESS" && <button className="sa-btn sa-btn-add w-100 mt-2" onClick={AdharNumber}>Send OTP</button>
                 )}
                 {userAdharData?.data?.status === "SUCCESS" && (
                   <div className="mt-3 fade-in-up">
                      <label className="modal-input-label">Verification OTP</label>
                      <input type="number" className="profile-input-field mt-1 mb-3" value={AadharOtp} onChange={handleAdharOtpChnage} placeholder="Enter 6-digit OTP" />
                      <button className="sa-btn sa-btn-add w-100" onClick={AdharOtpFunc}>Verify & Complete</button>
                   </div>
                 )}
              </div>
            )}
           {SData.offlineKYC && (
              <div className="tab-pane fade" id="offline">
                 <div className="d-flex flex-column gap-3 w-100">
                   <input type="text" className="profile-input-field" placeholder="Full Legal Name" value={Names} onChange={(e)=>setNames(e.target.value)} />
                   <input type="text" className="profile-input-field" placeholder="ADHAR Number" value={AadharNum} onChange={handleAdharChnage} />
                   <input type="date" className="profile-input-field" value={DOB} onChange={(e)=>setDob(e.target.value)} />
                   
                   <div className="file-upload-box">
                      <label className="d-block mb-1 text-xs text-muted">Front Document Photo</label>
                      <input type="file" onChange={(e)=>setFrontLoaded(e.target.files)} accept="image/*" className="file-native-input" />
                   </div>
                   <div className="file-upload-box">
                      <label className="d-block mb-1 text-xs text-muted">Back Document Photo</label>
                      <input type="file" onChange={(e)=>setBackLoaded(e.target.files)} accept="image/*" className="file-native-input" />
                   </div>
                   
                   <button className="sa-btn sa-btn-add w-100 mt-2" onClick={handleSubmitdata}>Submit Verification Data</button>
                 </div>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Profile1;